import { SvgIcon } from "@mui/material";
import { FC } from "react";

const AdminBootstrapIcon: FC<{ active?: boolean; size?: number }> = ({
  size = 24,
}) => (
  <SvgIcon
    viewBox="0 0 24 24"
    aria-hidden="true"
    sx={{ fontSize: size, display: "block" }}
  >
    <path
      d="M9 6.75h8.25c.97 0 1.75.78 1.75 1.75v8.25c0 .97-.78 1.75-1.75 1.75H9c-.97 0-1.75-.78-1.75-1.75V8.5c0-.97.78-1.75 1.75-1.75Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path
      d="M5.5 14.6V7.25c0-.97.78-1.75 1.75-1.75h7.35"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.7"
    />
    <path
      d="M10.1 10.4h6.1m-6.1 2.8h6.1m-6.1 2.8h4.1"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.7"
    />
  </SvgIcon>
);

export default AdminBootstrapIcon;
